export const MAX_DESKTOP_TEXTAREA_HEIGHT_PIXELS = 96;
